import React from "react";
import {
  LineChart, Line, XAxis, YAxis, Tooltip, ResponsiveContainer, PieChart, Pie, Cell
} from "recharts";
import "./AdminDashboard.css";

const lineData = [
  { name: "Jan", views: 20000, subs: 10000 },
  { name: "Feb", views: 35000, subs: 15000 },
  { name: "Mar", views: 60000, subs: 30000 },
  { name: "Apr", views: 80000, subs: 40000 },
  { name: "May", views: 120000, subs: 60000 },
  { name: "Jun", views: 150000, subs: 70000 },
  { name: "Jul", views: 180000, subs: 90000 },
  { name: "Aug", views: 200000, subs: 120000 }
];

const pieData = [
  { name: "Mobile", value: 15000 },
  { name: "Desktop", value: 8000 },
  { name: "Tablet", value: 3648 }
];

const COLORS = ["#8A2BE2", "#00C49F", "#FFBB28"];

export default function AdminDashboard({ onLogout }) {
  const user = JSON.parse(localStorage.getItem("user"));

  return (
    <div className="admin-container">
      {/* Sidebar */}
      <div className="admin-sidebar">
        <h4>Stocks4U</h4>
        <ul className="nav flex-column">
          <li>
            <button type="button" className="nav-link">
              Dashboard
            </button>
          </li>
          <li>
            <button type="button" className="nav-link">
              Reports
            </button>
          </li>
        </ul>
        <div className="user-info">
          <p>{user?.email}</p>
          <button className="btn btn-sm btn-outline-light w-100" onClick={onLogout}>
            Log Out
          </button>
        </div>
      </div>

      {/* Main Section */}
      <div className="admin-main">
        <h2>Welcome back, {user?.email}</h2>

        {/* Stats Cards */}
        <div className="admin-stats">
          <div className="admin-card">
            <h5>Page Views</h5>
            <h3>50.8K</h3>
          </div>
          <div className="admin-card">
            <h5>Monthly Subscriptions</h5>
            <h3>23.6K</h3>
          </div>
          <div className="admin-card">
            <h5>All-time Subscriptions</h5>
            <h3>23.6K</h3>
          </div>
        </div>

        {/* Line Chart */}
        <div className="admin-chart">
          <h5>Page Views vs Subscriptions</h5>
          <ResponsiveContainer width="100%" height={300}>
            <LineChart data={lineData}>
              <XAxis dataKey="name" stroke="#ccc" />
              <YAxis stroke="#ccc" />
              <Tooltip />
              <Line type="monotone" dataKey="views" stroke="#8A2BE2" strokeWidth={2} />
              <Line type="monotone" dataKey="subs" stroke="#00C49F" strokeWidth={2} />
            </LineChart>
          </ResponsiveContainer>
        </div>

        {/* Reports Overview + Pie Chart */}
        <div className="row">
          <div className="col-md-6">
            <div className="admin-report">
              <h5>Report Overview</h5>
              <ul>
                <li>Basic Plan - 5</li>
                <li>Pro - 8</li>
                <li>Business - 12</li>
                <li>Learning Videos - 9</li>
              </ul>
            </div>
          </div>
          <div className="col-md-6">
            <div className="admin-report">
              <h5>Users by Device</h5>
              <ResponsiveContainer width="100%" height={250}>
                <PieChart>
                  <Pie
                    data={pieData}
                    dataKey="value"
                    nameKey="name"
                    cx="50%"
                    cy="50%"
                    outerRadius={80}
                    fill="#8884d8"
                    label
                  >
                    {pieData.map((entry, index) => (
                      <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
                    ))}
                  </Pie>
                </PieChart>
              </ResponsiveContainer>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
